import type { UserRole } from "@/types/api";

/** Roles permitted to view/manage the Users admin surface. */
export const USERS_ADMIN_ROLES: readonly UserRole[] = [
  "SuperAdmin",
  "OrgAdmin",
];

/** Whether the given role is allowed to manage users. */
export function canManageUsers(role: UserRole | undefined): boolean {
  if (!role) return false;
  return USERS_ADMIN_ROLES.includes(role);
}

/**
 * Roles permitted to edit per-schedule master data (Rooms, Subject Areas).
 * Mirrors the backend `OrgAdminOrAbove` policy gating these endpoints.
 */
export const SCHEDULE_MASTER_DATA_ROLES: readonly UserRole[] = [
  "SuperAdmin",
  "OrgAdmin",
];

/** Whether the given role is allowed to edit a schedule's Rooms / Subject Areas. */
export function canManageScheduleMasterData(
  role: UserRole | undefined,
): boolean {
  if (!role) return false;
  return SCHEDULE_MASTER_DATA_ROLES.includes(role);
}
